module.exports = "./img/d2b4db4690175f9103a7bc0d3d492f1f.jpg";